










































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class PerhitunganStep extends Vue {
  @Prop({ default: null }) session!: any;

  get pctClass() {
    const p = Number((this.session && this.session.capaian_pct) || 0);
    if (p >= 100) return "success--text";
    if (p >= 95) return "light-green--text";
    if (p >= 80) return "orange--text";
    return "red--text";
  }

  get kategoriColor() {
    const k = this.session && this.session.kategori_kepatuhan;
    if (k === "eksellen") return "success";
    if (k === "baik") return "light-green";
    if (k === "cukup") return "orange";
    if (k === "kurang") return "red";
    return "grey";
  }

  get labelKategori() {
    const k = this.session && this.session.kategori_kepatuhan;
    if (!k) return "-";
    return k.charAt(0).toUpperCase() + k.slice(1);
  }
}
